module.exports = __webpack_public_path__ + "img/topics2.7ba80d82.jpg";